import React, { FC, useEffect, useRef, useState } from "react";
import { Pressable, View, useWindowDimensions, Animated, Easing, TouchableOpacity, FlatList, Image, BackHandler } from "react-native";
import { ThemeConsumer } from "@rneui/themed";
import AsyncStorage from "@react-native-async-storage/async-storage";
import base64 from "react-native-base64";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { appSignIn, changePinApi, updatePinApi, verifyTokenApi } from "../../redux/slices/authSlice";
import { getCountry, getCurrentUser, getDisplaySetting, getPosUserRolesAndPermissions, getStoreLocation, loginState, setCurrentLocation, setIndustryDetails, setSignInResponse } from "../../redux/slices/commonSlice";

import { useAppNavigation, useAppRoute } from "../../types/@react-navigation/navigation";

import { ZenButton, ZenIcon, ZenLoader, ZenStatusBar, ZenText, ZenToast } from "zen-core-elements";

import InActivityScreen from './inActivityScreen'
import { CustomModal } from "../../shared/commonComponents/customModal";
import { config } from "../../shared/environment";
import { usePinKeyboard } from "../../platform/auth/usePinKeyboard";

//pin type props
type PinProps = {
    type: 'ChangePin' | 'loginPin' | "UpdatePin"
}
type PinType = { id: number, focus: boolean, value: number }
// Marks "server refused the email/PIN" as opposed to a network/server failure
const INVALID_PIN = "INVALID_PIN"
const Pin: FC<PinProps> = ({ type }) => {

    //variable to store windowsDimentions
    const { width } = useWindowDimensions()
    //variable to store useNavigation value
    const navigation = useAppNavigation()
    const route = useAppRoute("ChangePin")
    //variable to store keyboard numbers
    const [numbers, setNumbers] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, null, 0, "backspace",])
    //variable to store PIN field value
    const [pin, setPin] = useState<PinType[]>([{ id: 0, focus: true, value: -1 }, { id: 1, focus: false, value: -1 }, { id: 2, focus: false, value: -1 }, { id: 3, focus: false, value: -1 }])
    //variable to handle PIN visiblity
    const [eye, setEye] = useState(false)
    //variable to store new PIN value
    const [newPin, setNewPin] = useState<number[]>([])
    //variable to handle confirmation PIN field
    const [isConfirmPin, setConfirmPin] = useState(false)
    //variable to handle cursor animation
    const cursorAnimation = useRef(new Animated.Value(0)).current;

    const dispatch = useAppDispatch()
    const [loader, setLoader] = useState(false)
    const inActive = useAppSelector((state) => state.common.displaySettingInActive)

    const signIn = async () => {
        setLoader(true)
        let email = await AsyncStorage?.getItem("Email")
        let pinValue = pin.map((data) => data?.value).join("")
        let base64String = "Basic " + base64?.encode(email + ":" + "pin:" + pinValue)
        handlePromise(base64String)
    }

    const handleAppSignInApi = async (base64String: string) => {
        try {
            const response = await dispatch(appSignIn(base64String)).unwrap()
            if (response?.message !== "Logged in succesfully") {
                setLoader(false)
                // The server answered and refused the email/PIN ("Failed to login", HTTP 206). No response at
                // all means a network/server failure (appSignIn resolves undefined then) - keep the generic message.
                throw new Error(response ? INVALID_PIN : "Failed to SignIn");
            }
            dispatch(setSignInResponse(response))
            await AsyncStorage?.setItem("LoginToken", JSON?.stringify(response?.accessToken))
            return response
        }
        catch (error: any) {
            throw new Error(error?.message === INVALID_PIN ? INVALID_PIN : "Failed to SignIn");
        }
    }
    const handleGetCountryApi = async () => {
        return new Promise((resolve, reject) => {
            try {
                //IMPORTANT: get country api is called intially called bcoz used in add/edit customer
                dispatch(getCountry(true))
                resolve(true)
            }
            catch (error) {
                reject(error)
            }
        })
    }
    const handleGetDisplaySettingApi = (storeId: number) => {
        return new Promise((resolve, reject) => {
            try {
                dispatch(getDisplaySetting({ storeId }))
                resolve(true)
            }
            catch (error) {
                reject(error)
            }
        })

    }
    const handleStoreLocationApi = async (storeId: number) => {
        try {
            let storeLocationResponse = await dispatch(getStoreLocation({ storeId: storeId }))?.unwrap()
            let { storeLocation: location } = storeLocationResponse
            dispatch(setCurrentLocation({ id: location[0]?.id, name: location[0]?.locationName, timeZone: location[0].timeZone }))
            return storeLocationResponse?.storeLocation[0]?.id
        }
        catch (error) {
            throw new Error("Failed to get store location")
        }
    }

    const handleUserRolesAndPermissionApi = async (storeId: number, roleId: number) => {
        await dispatch(getPosUserRolesAndPermissions({ storeId, id: roleId })).unwrap().then((res) => {
            return true
        }).catch((err: string) => {
            throw new Error("Failed to get store location")
        })
    }
    const handleCurrentUserApi = async () => {
        try {
            const currentUserResponse = await dispatch(getCurrentUser()).unwrap()
            let { currentUser } = currentUserResponse
            dispatch(setIndustryDetails({ name: currentUser?.industry?.name }))
            return true
        }
        catch (error) {
            throw new Error("Failed to get current user")
        }
    }
    // Local
    // const handlePromise = async (base64String: string) => {
    //     await Promise.all([
    //         handleGetDisplaySettingApi(271),
    //         handleGetCountryApi(),
    //         handleStoreLocationApi(271),
    //         handleUserRolesAndPermissionApi(271, 90),
    //         handleCurrentUserApi()
    //     ]).then(async ([]) => {
    //         await handleAsyncStoreageValues();
    //         dispatch(loginState(true))
    //         ZenToast({
    //             type: "success",
    //             message: "Login succesfully"
    //         })
    //     }).catch(() => {
    //         setLoader(false)
    //         ZenToast({ message: "Something went wrong", type: "error" })
    //     })
    // }

    //DEV
    const handlePromise = async (base64String: string) => {
        await handleAppSignInApi(base64String).then(async (signInResponse) => {
            await Promise.all([
                handleGetDisplaySettingApi(signInResponse?.user?.storeId),
                handleGetCountryApi(),
                handleStoreLocationApi(signInResponse?.user?.storeId),
                signInResponse?.user?.posRoleId && handleUserRolesAndPermissionApi(signInResponse?.user?.storeId, signInResponse?.user?.posRoleId),
                handleCurrentUserApi()
            ]).then(async () => {
                dispatch(loginState(true))
    await handleAsyncStoreageValues();
                ZenToast({
                    type: "success",
                    message: "Login succesfully"
                })
            })
        }).catch((error) => {
            console.log("App signin error", error)
            setPin(() => {
                let data: PinType[] = [{ id: 0, focus: true, value: -1 },
                { id: 1, focus: false, value: -1 },
                { id: 2, focus: false, value: -1 },
                { id: 3, focus: false, value: -1 }]
                return data
            })
            // A refused PIN gets its own message; previously it was immediately replaced by the generic one
            const invalidPin = error?.message === INVALID_PIN
            ZenToast({
                type: invalidPin ? "warning" : "error",
                message: invalidPin ? "Please enter a valid Pin" : "Failed to login please try again later"
            })
        }).finally(() => {
            setLoader(false)
        })
    }

    const handleAsyncStoreageValues = async () => {
        // Storage Keys
        const RETURN_WINDOW_STORAGE_KEY = `@order_settings_return_window_${config.storeId}`;
        const ORDER_ID_STORAGE_KEY = `@order_settings_order_id_${config.storeId}`;
        const returnWindowData = await AsyncStorage.getItem(RETURN_WINDOW_STORAGE_KEY);
        const orderIdData = await AsyncStorage.getItem(ORDER_ID_STORAGE_KEY);
        if (!returnWindowData) {
            await AsyncStorage.setItem(RETURN_WINDOW_STORAGE_KEY, "14_DAYS");
        }
        if (!orderIdData) {
            const defaultOrderId = {
                orderIdPrefixText: "ZEN",
                orderIdSuffixText: "ID",
            };
            await AsyncStorage.setItem(ORDER_ID_STORAGE_KEY, JSON.stringify(defaultOrderId));
        }
    };

    useEffect(() => {
        const onBackPress = BackHandler.addEventListener("hardwareBackPress", () => {
            if (type === "UpdatePin") {
                return true;
            }
            return false;
        });
        return () => onBackPress.remove();
    }, [])

    //useEffect for cursor animation
    useEffect(() => {
        const moveCursor = () => {
            Animated.loop(
                Animated.sequence([
                    Animated.timing(cursorAnimation, {
                        toValue: 0.5,
                        duration: 300,
                        easing: Easing?.linear,
                        useNativeDriver: true
                    }),
                    Animated.timing(cursorAnimation, {
                        toValue: 1,
                        duration: 300,
                        easing: Easing?.linear,
                        useNativeDriver: true,
                    }),
                ])
            ).start(() => moveCursor());
        };

        moveCursor();
    }, [cursorAnimation]);

    //useEffect for handle confirmation pin field
    useEffect(() => {
        if (isConfirmPin) {
            setPin([{ focus: true, value: -1, id: 0 }, { focus: false, value: -1, id: 1 }, { focus: false, value: -1, id: 2 }, { focus: false, value: -1, id: 3 }])
            setNumbers([1, 2, 3, 4, 5, 6, 7, 8, 9, "arrow-back", 0, "backspace"])
        }
        else {
            if (newPin?.length) {
                setPin([{ focus: false, value: newPin[0], id: 0 }, { focus: false, value: newPin[1], id: 1 }, { focus: false, value: newPin[2], id: 2 }, { focus: false, value: newPin[3], id: 3 }])
                setNumbers([1, 2, 3, 4, 5, 6, 7, 8, 9, null, 0, "backspace"])
            }
        }
    }, [isConfirmPin])

    //Method for handle cursor animation
    const cursorWidth = cursorAnimation.interpolate({
        inputRange: [0, 0.5],
        outputRange: [0, 1],
    });
    //Method to generate a PIN
    const generatePin = (number: number | string | null) => {
        if (number == 'backspace') {
            handleBackspace()
        }
        else if (number == 'arrow-back') {
            setConfirmPin(false)
        }
        else if (typeof number == "number") {
            handleNumberInput(number);
        }
    }
    const handleNumberInput = (number: number) => {
        let data = [...pin]
        setPin(() => {
            let indexValue = 1
            if (data?.some((value) => value?.focus)) {
                updateFocusedPinForNumberInput(data, number, indexValue)
            }
            return data
        })
        // Only the login screen submits on the 4th digit; Change/Set PIN continue with their Next button.
        if (type === "loginPin" && data.every((item) => item?.value != -1)) {
            signIn()
        }
    }
    const updateFocusedPinForNumberInput = (data: PinType[], number: number, indexValue: number) => {
        data.forEach((item, index) => {
            if (item?.focus) {
                item.value = number
                item.focus = false
                indexValue = (data?.length <= index + 1) ? 100 : index + 1
            }
        })
        if (indexValue != 100) {
            data[indexValue].focus = true
        }
    }
    const handleBackspace = () => {
        setPin((prev) => {
            let data = [...prev]
            let pincheck = data?.filter((value) => value?.focus)
            if (pincheck?.length) {
                updateFocusedPinForBackspace(data, pincheck)
            }
            else if (data[0]?.value != -1) {
                data[data?.length - 1].value = -1
                data[data?.length - 1].focus = true
            }
            return data
        })
    }
    const updateFocusedPinForBackspace = (data: PinType[], pincheck: PinType[]) => {
        if (pincheck[0]?.value != -1) {
            data[pincheck[0]?.id].value = -1
            data[pincheck[0]?.id].focus = true
        }
        else if (pincheck[0]?.id - 1 >= 0) {
            data[pincheck[0]?.id].focus = false
            data[pincheck[0]?.id - 1].value = -1
            data[pincheck[0]?.id - 1].focus = true
        }
    }

    //Method for focus the cursor
    const cursorFocus = (value: PinType, index: number) => {
        if (value?.value != -1 || (pin[index - 1]?.value != -1)) {
            setPin((prev) => {
                let data = [...prev]
                data?.forEach((item, indexValue) => {
                    if (indexValue == index) {
                        item.focus = true
                    } else {
                        item.focus = false
                    }
                })
                return data
            })
        }
    }

    //Method for check the PIN values
    const valueCheck = () => {
        let data = false
        data = pin.every((item) => item?.value != -1)
        return data
    }


    //Method for check the confirmation PIN values
    const confirmPinCheck = () => {
        let value = false
        value = pin.every((data, index: number) => (data?.value == newPin[index]))
        return value
    }
    //Method for save the PIN
    const savePin = () => {
        let data: number[] = []
        pin?.map((item) => {
            data?.push(item?.value)
        })
        if (isConfirmPin) {
            if (type == "ChangePin")
                changePin(data.join(""))
            else
                updatePin(data.join(""))
        } else {
            setNewPin(data)
            setConfirmPin(true)
        }
    }
    const updatePin = async (pinValue: string) => {
        setLoader(true)
        let email = await AsyncStorage?.getItem("registerMail")
        let registration = await AsyncStorage.getItem("signupRegistration") as string
        let pin = "Basic " + base64?.encode(email + ":" + "pin:" + pinValue)
        await dispatch(updatePinApi({ pin, registration })).unwrap().then((response) => {
            if (response?.success) {
                ZenToast({
                    type: "success",
                    message: "Pin updated successfully"
                })
                navigation?.navigate("SignIn")
            }
            else {
                ZenToast({
                    type: "error",
                    message: "Failed to update the pin, Please try again after some time"
                })
            }
        }).catch((error) => {
            ZenToast({
                type: "error",
                message: "Failed to update the pin, Please try again after some time"
            })
            console?.log("Pin update error", error)
        }).finally(() => {
            setLoader(false)
        })
    }
    const changePin = async (pinValue: string) => {
        let { token } = route?.params ?? {}
        if (!token) {
            // Opened without the token from the reset/set-PIN email link.
            ZenToast({
                type: "error",
                message: "The link has expired. Please try using the new link."
            })
            return
        }
        setLoader(true)
        let email = await AsyncStorage?.getItem("Email")
        let base64String = "Basic " + base64?.encode(email + ":" + "pin:" + pinValue)
        await dispatch(verifyTokenApi({ token }))?.unwrap().then(async (response) => {
            let clientId = response?.user?.clientId
            if (clientId) {
                await dispatch(changePinApi({ base64String, clientId, token })).unwrap().then((response) => {
                    if (response?.success) {
                        ZenToast({
                            type: "success",
                            message: "Pin changes successfully"
                        })
                        navigation?.navigate("SignIn")
                    }
                    else {
                        ZenToast({
                            type: "error",
                            message: "Failed to change the pin, Please try again after some time"
                        })
                    }
                }).catch((error) => {
                    ZenToast({
                        type: "error",
                        message: "Failed to change the pin, Please try again after some time"
                    })
                    console?.log("Pin change error", error)
                }).finally(() => {
                    setLoader(false)
                })
            }
        }).catch((error) => {
            ZenToast({
                type: "error",
                message: "The link has expired. Please try using the new link."
            })
            console?.log("Token check error", JSON.stringify(error, null, 4))
        }).finally(() => {
            setLoader(false)
        })
    }

    // Web: number keys / Backspace drive the keypad. No-op on native.
    usePinKeyboard(generatePin, !inActive && !loader)

    if (inActive) {
        return (
            <InActivityScreen />
        )
    }

    return (
        <ThemeConsumer>
            {({ theme }) => (
                <View style={[theme?.pinStyle?.outerContainer, { flexDirection: width > 900 ? "row" : "column" }]}>
                    <ZenStatusBar bgColor={theme?.primary} barStyle={"light-content"} />
                    {navigation?.canGoBack() && type != "UpdatePin" && <TouchableOpacity style={{ position: "absolute", top: 20, marginStart: 20 }} onPress={() => navigation?.navigate("SignIn")}>
                        <ZenIcon name={"arrow-left"} type={"material-community"} size={width > 600 ? 28 : 22} color={theme?.dark} />
                    </TouchableOpacity>}
                    <View style={{ flex: width < 600 ? 0.45 : 0.5, top: width > 900 ? -30 : 0 }}>
                        <View style={theme?.pinStyle?.fieldOuterContainer}>
                            <View style={theme?.pinStyle?.fieldOuterContainer}>
                                <Image source={require('../../assets/pin.jpg')} style={{ width: width > 900 ? 400 : width > 600 ? 350 : 270, height: width > 900 ? 270 : width > 600 ? 200 : 120 }} resizeMode="contain" />
                                <ZenText content={type == 'loginPin' ? "Please enter your PIN to proceed" : isConfirmPin ? "Confirm PIN" : "New PIN"} bold={true} size={theme?.mediumFontSize} color={theme?.dark} />
                                <View style={theme?.pinStyle?.fieldInnerContainer}>
                                    {
                                        pin.map((value, index) => (
                                            <Pressable key={index} onPress={() => { cursorFocus(value, index) }} style={[theme?.pinStyle?.pinFieldValue, { width: width > 600 ? 50 : 45, height: width > 600 ? 50 : 30, margin: width > 600 ? 20 : 15 }]}>
                                                <Animated.View style={[theme?.pinStyle?.animatedCursor, { opacity: value?.focus ? cursorWidth : 1, height: value?.focus ? 3 : 1, }]}></Animated.View>
                                                {(eye && value?.value != -1) ? <ZenText content={value?.value.toString()} bold={true} size={width > 600 ? 22 : theme?.mediumFontSize} color={theme?.dark} style={{ textAlign: "center", }} /> :
                                                    <ZenText content={(value?.value != -1) ? "*" : ""} bold={true} size={width > 600 ? 30 : 22} color={theme?.dark} style={{ textAlign: "center", }} />}
                                            </Pressable>
                                        ))
                                    }
                                    <View style={[theme?.pinStyle?.securityView, { top: width > 600 ? -10 : -5 }]}>
                                        <TouchableOpacity onPress={() => { setEye(!eye) }} >
                                            <ZenIcon name={eye ? "eye" : "eye-off"} type="material-community" size={width > 600 ? 26 : 18} color={theme?.iconColor} />
                                        </TouchableOpacity>
                                    </View>
                                </View>
                                {type == "loginPin" && <TouchableOpacity style={{ alignSelf: "flex-end", marginTop: -10 }} onPress={() => { navigation?.navigate("ForgotPin") }}>
                                    <ZenText content={"Forgot pin"} color={theme?.labelColor} bold={true} size={theme?.smallFontSize} />
                                </TouchableOpacity>}
                                {isConfirmPin && !confirmPinCheck() && valueCheck() ? <ZenText content={"Incorrect PIN"} bold={true} size={width > 600 ? 18 : theme?.errorFontSize} color={theme?.red} style={{ marginBottom: 10 }} /> : null}
                                {type == 'loginPin' ?
                                    <></>
                                    // <ZenButton
                                    //     title={"Proceed"}
                                    //     onPress={signIn}
                                    //     disabled={!valueCheck()}
                                    //     buttonStyle={theme?.pinStyle?.buttonStyle}
                                    //     containerStyle={{ marginVertical: width > 600 ? 20 : 10 }}
                                    //     titleStyle={theme?.pinStyle?.titleStyle}
                                    // />
                                    : <ZenButton
                                        title={isConfirmPin ? "Save" : "Next"}
                                        onPress={() => { savePin() }}
                                        disabled={isConfirmPin ? (!valueCheck() || !confirmPinCheck()) : !valueCheck()}
                                        buttonStyle={theme?.pinStyle?.buttonStyle}
                                        containerStyle={{ marginVertical: width > 600 ? 20 : 10 }}
                                        titleStyle={theme?.pinStyle?.titleStyle}
                                    />}
                            </View>
                        </View>
                    </View>
                    <View style={[theme?.pinStyle?.keyboardOuterView, width > 900 ? { flex: 0.45, } : width > 600 ? { flex: 0.41 } : { flex: 0.5, zIndex: 10 }]}>
                        <FlatList
                            data={numbers}
                            keyExtractor={(_, index) => index?.toString()}
                            numColumns={3}
                            renderItem={({ item }) => (
                                <View style={[theme?.pinStyle?.keypadButton, width > 600 ? { width: 100 } : { width: 70 }]}>
                                    <TouchableOpacity
                                        onPress={() => generatePin(item)}
                                        style={[
                                            theme?.pinStyle?.buttonTouchable,
                                            {
                                                backgroundColor: (item == null || item == 'arrow-back' || item == 'backspace')
                                                    ? 'transparent'
                                                    : theme?.lightBackgroundColor,
                                                elevation: (item == null || item == 'arrow-back' || item == 'backspace') ? 0 : 2,
                                            }
                                        ]}
                                    >
                                        {typeof item === 'number' ? (
                                            <ZenText
                                                content={item.toString()}
                                                style={[theme?.pinStyle?.buttonText, width > 600 ? { fontSize: 24, } : { fontSize: theme?.headerFontSize }]}
                                            />
                                        ) : item === 'backspace' || item == 'arrow-back' ? (
                                            <ZenIcon
                                                name={item}
                                                type="material"
                                                size={width > 600 ? 28 : 22}
                                                color={theme?.iconColor}
                                            />
                                        ) : null}
                                    </TouchableOpacity>
                                </View>
                            )}
                            contentContainerStyle={theme?.pinStyle?.keypadContainer}
                            scrollEnabled={false}
                        />
                    </View>

                    <CustomModal visible={loader} transparent>
                        <ZenLoader viewStyle={{ flex: 1, justifyContent: "center", alignItems: "center", backgroundColor: "transparent" }} color={theme?.primary} lottieType="Local" lottie={require('../../assets/infinityLoader.json')} />
                    </CustomModal>

                </View >
            )
            }
        </ThemeConsumer >
    )
}
export default Pin